import React, { useContext } from 'react';
import { T } from '@transifex/react';

import { useHistory } from 'src/routing/child-router-factory';
import { PropertyContext } from 'src/context/property-context';

import { RouterContext } from 'src/context/routing';

export const QuickActions = () => {
  const { routingMap } = useContext(RouterContext);
  const { ticketTypes } = useContext(PropertyContext);
  const history = useHistory();

  if (!ticketTypes.length) {
    return null;
  }

  return (
    <section className="flex flex-col gap-6">
      <span className="text-xs font-medium uppercase leading-none tracking-[0.05em] text-[var(--text-secondary)]">
        <T _str="Quick actions" />
      </span>
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {ticketTypes.map((ticketType: $TSFixMe) => {
          const { id, name } = ticketType;
          return (
            <button
              type="button"
              key={id}
              onClick={() =>
                history.push(
                  routingMap.app.selfService['create/:ticketTypeId'](id)._
                )
              }
              className="flex flex-col items-start gap-4 rounded-2xl border border-[var(--border-default)] bg-[var(--bg-surface)] p-8 text-left transition-colors hover:bg-[var(--bg-hover)]"
            >
              <h3 className="line-clamp-2 text-base font-semibold leading-normal text-[var(--text-primary)]">
                {name}
              </h3>
            </button>
          );
        })}
      </div>
    </section>
  );
};
